<template>
  <div class="px-3 main-wrapper">
    <div class="mt-3">
      <div class="col-12 px-1 mb-5 pb-5">
        <h2
          class="text-white text-center mt-5"
          v-if="!promotions || promotions.length === 0"
        >
          Coming Soon ...
        </h2>
        <div
          v-else
          class="mt-2 mb-3 py-3 px-2 flex items-center justify-between"
          style="box-shadow: none; background: #2b1c59; border-radius: 10px"
          v-for="(promotion, proIndex) in promotions"
          :key="proIndex"
        >
          <div class="flex w-full flex-col gap-3">
            <a
              href="#"
              class=""
            >
              <img
                :src="promotion.image"
                style="
                  border-top-left-radius: 0.5rem;
                  border-top-right-radius: 0.5rem;
                  width: 100%;
                "
                alt=""
              />
            </a>
            <div class="flex w-full items-center justify-between">
              <div class="px-3 py-2 mt-3 d-flex justify-content-between">
                <h3 class="text-white my-auto">
                  <img
                    src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f4b8/512.gif"
                    alt="💸"
                    width="25"
                    height="25"
                  />
                  <p class="mt-2">
                    {{ promotion.title }}
                  </p>
                </h3>
              </div>
              <button
                class="detail-button text-white col-3 my-2"
                @click="promotionIndex(proIndex)"
              >
                {{ $t("detail") }}
              </button>
            </div>
          </div>

          <van-overlay
            :show="selectedPromotion === proIndex"
            @click="selectedPromotion = null"
          >
            <div class="wrapper col-12 d-flex h-100vh">
              <div
                class="col-12 mx-auto my-auto py-4 px-4"
                style="background: #202124 !important"
              >
                <h2
                  class="pb-3"
                  style="color: #fff"
                >{{ promotion.title }}</h2>
                <span
                  style="color: #fff"
                  v-html="promotion.description"
                ></span>
                <div class="d-flex gap-3 mt-4">
                  <a
                    v-if="promotion.social_links?.telegram"
                    :href="promotion.social_links.telegram"
                    target="_blank"
                    title="Telegram"
                    class="mr-3"
                  >
                    <img
                      src="icons/telegram.png"
                      alt="Telegram"
                      width="30"
                      height="30"
                    />
                  </a>

                  <a
                    v-if="promotion.social_links?.viber"
                    :href="`viber://chat?number=${promotion.social_links.viber}`"
                    title="Viber"
                  >
                    <img
                      src="icons/viber.png"
                      alt="Viber"
                      width="30"
                      height="30"
                    />
                  </a>
                </div>
              </div>
            </div>
          </van-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      isPromotionsFetching: false,
      selectedPromotion: null,
      promotions: [],
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    async fetchPromotions() {
      this.isPromotionsFetching = true;
      try {
        const res = await axios.get("/promotions", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        this.promotions = res.data.data;
      } catch (e) {
        console.error(e);
        this.$toast.fail("Failed!");
      } finally {
        this.isPromotionsFetching = false;
      }
    },
    promotionIndex(index) {
      this.selectedPromotion = index;
    },
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push("/auth/login");
    }
    this.fetchPromotions();
    this.$store.commit('setLoading', false);
  },
};
</script>
<style scoped>
.detail-button {
  appearance: none;
  background-image: linear-gradient(rgb(221, 36, 193),
      rgb(176, 0, 149)) !important;
  color: white !important;
  border: none;
  text-transform: uppercase;
  border-radius: 100px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  padding: 10px 15px;
  min-height: 15px;
  min-width: 0;
  outline: none;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(0.23, 1, 0.32, 1);
  user-select: none;
  touch-action: manipulation;
  height: max-content;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  background: linear-gradient(to bottom,
      #ffc500 0%,
      #ff4500 50%,
      #c71600 100%) !important;
  color: white !important;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
  background: #2b2c2e;
}

.animate-charcter {
  text-transform: uppercase;
  background-image: linear-gradient(-225deg,
      #b50200 0%,
      #f3e706 29%,
      #b50200 67%,
      #f3e706 100%);
  background-size: 200% auto;
  color: #fff;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: textclip 2s linear infinite;
  display: inline-block;
}

@keyframes textclip {
  to {
    background-position: 200% center;
  }
}
</style>
